/**
 * Filters API Endpoints
 * Centralized endpoint definitions for filter operations.
 */
export const FILTERS_ENDPOINTS = {
  /**
   * Get locations and instruments
   * @method GET
   * @endpoint /filters/locations
   */
  LOCATIONS: "/filters/locations",

  /**
   * Get sample types
   * @method GET
   * @endpoint /filters/sample-types
   */
  SAMPLE_TYPES: "/filters/sample-types",

  /**
   * Get visit types
   * @method GET
   * @endpoint /filters/visit-types
   */
  VISIT_TYPES: "/filters/visit-types",

  /**
   * Get requesters
   * @method GET
   * @endpoint /filters/requesters
   */
  REQUESTERS: "/filters/requesters",

  /**
   * Get ordering doctors
   * @method GET
   * @endpoint /filters/doctors
   */
  DOCTORS: "/filters/doctors",
} as const;
